export default "/images/mainBg.svg?f0f3810c0244fc5d86472eec4732dbf6";